// extracted by mini-css-extract-plugin
export default {"root":"LabelRow_root__Z+tOh","label":"LabelRow_label__cUiRo","right":"LabelRow_right__UtGn4","required":"LabelRow_required__OuC+z","select":"LabelRow_select__y6Lz6"};